export default {
    FRAME: 'FRAME',
    IMAGE_LINK: 'IMAGE_LINK',
    MENTION: 'MENTION',
    OTHER: 'OTHER',
    REDIRECT: 'REDIRECT',
    TEXT_LINK: 'TEXT_LINK',
};
